import React from 'react';
import './AlumnosFaltantes.css';
import HeaderComponent from '../../components/AlumnosFaltantes/Header/Header';
import AlumnosFaltantesComponent from '../../components/AlumnosFaltantes/AlumnosFaltantes/AlumnosFaltantes';

const AlumnosFaltantes = () => {
    return (
      <div className= "contenedor-derecho-prefectos fade-in">
        <div>
            <HeaderComponent />
        </div>
        <div>
            <AlumnosFaltantesComponent />
        </div>
      </div>
    );
  };
  
export default AlumnosFaltantes;

